import { useTypedSelector } from ".";
import { Group } from "../../types";

export const useGroupHome = (): Group | null =>
  useTypedSelector(state => state.group.groupHome);
